import { graphql, useStaticQuery } from 'gatsby'

export const useHeaderImagesLarge = () => {
    const images = useStaticQuery(
        graphql`
            query HeaderImagesLarge {
                allImageSharp {
                    edges {
                        node {
                            gatsbyImageData(height: 55, layout: FIXED)
                            parent {
                                ... on File {
                                    name
                                    ext
                                }
                            }
                        }
                    }
                }
            }
        `
    )
    // noinspection JSUnresolvedVariable
    return images.allImageSharp.edges
}
